import { server } from '../Data/BuildEnvironment'
import { HttpRequest } from '../Data/HttpRequest'

export function retrieveWithDetails(
    manufacturerId: number,
    prismaRequestId: number,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            `${server}/manufacturers/${manufacturerId}/` +
            `prisma-requests-with-details/${prismaRequestId}`,
        headers: {
            Accept: 'application/json',
        },
    }
}

export function markAsDispatched(
    prismaRequestId: number,
    data: { parcelDispatcherId: number, trackingNumber: string },
): HttpRequest {
    return {
        verb: 'POST',
        url:
            `${server}/prisma-request/${prismaRequestId}/dispatch`,
        headers: {
            Accept: 'application/json',
        },
        body: JSON.stringify(data),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PrismaRequestResource.ts